import { t } from "i18next";

import { MoreVert } from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import { UserNotificationDTO } from "@/src/types/types";
import { getAgoDuration } from "@/src/utils/notificationUtils";
import { addThousandsSeparator } from "@/src/utils/numberUtils";

interface NotificationItemProps {
  notification: UserNotificationDTO;
  handleClick: (
    notificationId: number,
    isRead: boolean,
    url?: string,
    contentData?: { auctionId?: number }
  ) => void;
  setSecondaryMenuAnchorEl: (params: {
    element: HTMLElement;
    notification: UserNotificationDTO;
  }) => void;
}

const NotificationItem = ({
  handleClick,
  setSecondaryMenuAnchorEl,
  notification
}: NotificationItemProps) => {
  const {
    isRead,
    id,
    actionUrl,
    notificationEventType,
    createdAt,
    contentData
  } = notification;
  return (
    <Grid container spacing={2}>
      <Grid
        onClick={() => {
          if (actionUrl) {
            handleClick(id, isRead, actionUrl, contentData);
          }
        }}
        size={10}
      >
        <Grid container>
          <Grid size={12}>
            <Typography
              variant="h5"
              sx={{
                cursor: "pointer",
                fontWeight: isRead
                  ? theme.typography.fontWeightMedium
                  : theme.typography.fontWeightExtrabold,
                fontStyle: isRead ? "normal" : "italic",
                mb: 1,
                whiteSpace: "break-spaces"
              }}
            >
              {t(`components.notifications.${notificationEventType}.title`)}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography
              variant="body2"
              sx={{
                display: "block",
                cursor: "pointer",
                fontStyle: "normal",
                whiteSpace: "break-spaces"
              }}
            >
              {t(`components.notifications.${notificationEventType}.content`, {
                regNo: contentData?.regNo,
                makeModel: contentData?.makeModel,
                oldBid: addThousandsSeparator(contentData?.oldBidAmount),
                newBid: addThousandsSeparator(contentData?.newBidAmount)
              })}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid size={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-end"
          }}
        >
          <Typography variant="caption" sx={{ mb: 1 }}>
            {getAgoDuration(createdAt, t)}
          </Typography>
          <IconButton
            onClick={(e) =>
              setSecondaryMenuAnchorEl({
                element: e.currentTarget,
                notification
              })
            }
            sx={{ mr: -2 }}
            size="small"
          >
            <MoreVert />
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NotificationItem;
